<template>
  <CmStateCard
    title="Причины ошибок"
    :is-loading="isLoading"
    :is-error="isError"
    :is-empty="!info || (info && !info.length)"
    class="push-statistics--errors-donut-card"
  >
    <CmDonutCard
      :center-label="
        fStr.getRusEnding(totalNum, ['ошибка', 'ошибки', 'ошибок'])
      "
      :center-value="totalNum"
      :value="info"
      :cols="cols"
      :get-tooltip-template="getTooltipTemplate"
    />
  </CmStateCard>
</template>

<script>
import CmStateCard from "@/components/library/statistics/cards/CmStateCard.vue";
import CmDonutCard from "@/components/library/statistics/cards/CmDonutCard.vue";

export default {
  name: "ErrorsCircle",

  components: {
    CmStateCard,
    CmDonutCard,
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},
    },
    errors: {
      type: Object,
    },
  },

  data() {
    return {
      cols: {
        text: {
          label: "Ошибка",
        },
        count: {
          label: "Количество",
          isPercent: true,
        },
      },
    };
  },

  computed: {
    info() {
      const formedData = [];

      if (
        !_.isEmpty(this.value) &&
        this.value.records &&
        this.value.records.length
      ) {
        this.value.records.forEach((item) => {
          formedData.push({
            text: this.errors[item.code]
              ? this.errors[item.code]
              : item.message,
            count: item.total,
            count_percent: item.percent,
          });
        });
      }
      return formedData;
    },

    totalNum() {
      return this.value && this.value.total ? this.value.total : 0;
    },
  },

  methods: {
    getTooltipTemplate(data) {
      return `<h4>${data.text}</h4>
        <b>${data.count}&nbsp;шт.</b>
        <span><b>${data.count_percent}%</b> от всех ошибок</span>`;
    },
  },
};
</script>

<style lang="scss">
.push-statistics--errors-donut-card {
  margin-bottom: 40px;
  .cm-title {
    margin: 0 0 40px;
  }
}
</style>